import { useState } from "react";
import Cookies from "js-cookie";
import AuthenticationContext from "./AuthenticationContext";
import { useEffect } from "react";
import { connection } from "services/services";
import { URL_ID, USER_TYPE } from "constants/constants.js";
import toast, { Toaster } from "react-hot-toast";

// admin access level: [5, 7, 8, 9, 10, 11, 12]
// customer access level : [13,14,15,16]
interface UserInformation {
  token: string;
  fullName: string;
  userType: number;
  mobile: number;
  userName: string;
  accessLevel: number[];
  id: any;
  isFirst: boolean;
}
export default function Authentication({ children }: { children: JSX.Element }) {
  const [userInfo, setUserInfo] = useState<UserInformation>({
    token: "",
    fullName: "",
    userType: -1,
    mobile: 0,
    userName: "",
    accessLevel: [],
    id: null,
    isFirst: true,
  });

  const [isLogged, setIsLogged] = useState<boolean>(false);

  useEffect(() => {
    checkCookie();
  }, []);

  function login(token: string, fullName: string, userType: number, mobile: number, userName: string, accessLevel: any[], id: any): void {
    // console.log("accessLevel in login", accessLevel);
    if (token) {
      if (userType == 1) {
        accessLevel = [13, 14, 15, 16];
      }
      setUserInfo({ token, fullName, userType: userType, mobile, userName, accessLevel, id: id, isFirst: false });

      setIsLogged(true);
      Cookies.set("token", token);
    }
  }

  function logout(): void {
    setUserInfo({ token: "", fullName: "", userType: -1, mobile: 0, userName: "", accessLevel: [], id: null, isFirst: false });
    setIsLogged(false);
    Cookies.remove("token");
  }

  function checkCookie(): void {
    if (Cookies.get("token")) {
      connection("checklogininfo").then((value) => {
        if (value.status == -1) {
          toast.error("کاربری با این مشخصات یافت نشد.");
          Cookies.remove("token");

          return "";
        }
        let userType;
        if (value.userinfo[0].isadmin == 1) {
          switch (+value.userinfo[0].user_admin_group) {
            case 1:
              userType = USER_TYPE.generalAdmin;
              break;
            case 2:
              userType = USER_TYPE.tourLeader;
              break;
            case 3:
              userType = USER_TYPE.accountants;
              break;
            case 4:
              userType = USER_TYPE.saleCounter;
              break;
            default:
              break;
          }
        } else {
          userType = USER_TYPE.customer;
        }
        // console.log("value", value);
        let accessLevel: number[] = [];
        for (const iterator of value.access_level) {
          accessLevel.push(+iterator.mid);
        }
        login(value.data.usertoken, value.userinfo[0].nikname, userType, value.userinfo[0].mobile, value.userinfo[0].username, [...accessLevel], value.userinfo[0].id);
      });
    } else {
      setUserInfo({
        token: "",
        fullName: "",
        userType: -1,
        mobile: 0,
        userName: "",
        accessLevel: [],
        id: null,
        isFirst: false,
      });
    }
  }

  return (
    <>
      <AuthenticationContext.Provider
        value={{
          login,
          userInfo,
          isLogged,
          logout,
        }}
      >
        {children}
      </AuthenticationContext.Provider>
    </>
  );
}
